import type { FC, HTMLAttributes, ReactNode } from 'react';
import { useRef } from 'react';

import { useModifiers } from '../../../styles/hooks/useModifiers';
import { Overscrollable, OverscrollableProps } from '../../overscrollable';

import styles from './ModalPages.module.css';

export interface ModalPagesProps extends HTMLAttributes<HTMLDivElement> {
  nav: ({ onNavigation }: { onNavigation: () => void }) => ReactNode;
  footer?: OverscrollableProps['footer'];
  isNavHidden?: boolean;
  isWideNav?: boolean;
  compactFooter?: boolean;
}

export const ModalPages: FC<ModalPagesProps> = ({ children, nav, footer, isNavHidden, isWideNav, ...rest }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const mods = useModifiers(styles, 'modalPages', { wide: isWideNav });
  const modsNav = useModifiers(styles, 'modalPages__nav', { hidden: isNavHidden });

  const onNavigation = (): void => {
    contentRef.current?.scrollTo(0, 0);
  };

  return (
    <div className={`${styles.modalPages} ${mods}`} {...rest}>
      <div className={`${styles.modalPages__nav} ${modsNav}`}>{nav({ onNavigation })}</div>
      <div className={styles.modalPages__content}>
        <Overscrollable ref={contentRef} footer={footer}>
          {children}
        </Overscrollable>
      </div>
    </div>
  );
};
